// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__-o70A","available":"styles_available__lVbGE","max":"styles_max__+S+ji","value":"styles_value__Woo6+"};